import { render } from "./receiptDisplay.vue?vue&type=template&id=bbebb8a2"
import script from "./receiptDisplay.vue?vue&type=script&lang=js"
export * from "./receiptDisplay.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Programming_And_Stuff\\Programming\\VueJs\\food-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__